// Guard de la tecla Escape para los <Modal> de react-bootstrap que abren SweetAlert encima.
//
// El problema (verificado leyendo las dos librerías y con un repro aislado):
//   - @restart/ui/Modal (el que usa react-bootstrap 2.x) escucha Escape con un listener de **keydown**
//     sobre `document`, y lo dispara mientras `modal.isTopModal()` sea true. Un SweetAlert NO es un
//     modal de react-bootstrap, así que aunque esté encima el modal de abajo se sigue considerando el
//     de más arriba y su handler sigue activo.
//   - sweetalert v2 cierra con **keyup** (`closeOnEsc`, activo por defecto).
//
// Como keydown ocurre antes que keyup, cada Escape presionado mientras hay un aviso abierto ejecutaba
// primero el `onHide` del modal —que en este módulo abre la confirmación de salida— y por eso el aviso
// que estuviera en pantalla quedaba reemplazado por "¿descartar cambios?", que a su vez ya no se podía
// cerrar con Escape (se reabría a sí misma en cada pulsación).
//
// La solución es no dejar que Escape llegue al `onHide` del modal cuando hay un SweetAlert visible:
// react-bootstrap llama a `onEscapeKeyDown` antes de cerrar y respeta `preventDefault()`. Con eso el
// keyup posterior lo maneja SweetAlert, que es a quien le corresponde ese Escape.
//
// `swal-overlay--show-modal` es la clase que sweetalert pone en el overlay solo mientras el aviso está
// visible (el nodo del overlay queda en el DOM aunque esté cerrado, por eso no sirve buscar `.swal-modal`).
export const handleSwalAwareEscapeKeyDown = (e) => {
  if (document.querySelector(".swal-overlay--show-modal")) {
    e.preventDefault();
  }
};

// Variante para el modal cuyo cierre pide confirmación con un SweetAlert (el formulario de registro).
//
// El guard de arriba no alcanzaba en ese caso: dejaba viva una carrera. En `keydown` se abría el aviso de
// confirmación, y el `keyup` de ESA MISMA pulsación podía llegar con el swal ya inicializado y cerrarlo al
// instante — el aviso parpadeaba y no pasaba nada.
//
// La solución es no abrir nada en `keydown`: se difiere hasta el `keyup`. Cuando el aviso aparece, la
// pulsación física ya terminó, así que el `closeOnEsc` de sweetalert no puede atraparla. El
// `preventDefault()` incondicional impide además que react-bootstrap cierre el modal sin confirmar.
let esperandoKeyUp = false;

export const makeSwalConfirmEscapeKeyDown = (requestClose) => (e) => {
  e.preventDefault();

  if (document.querySelector(".swal-overlay--show-modal")) return;
  if (esperandoKeyUp) return;

  esperandoKeyUp = true;
  const onKeyUp = (ev) => {
    // Solo el keyup de Escape cierra el ciclo. Sin este filtro, soltar cualquier OTRA tecla mientras se
    // mantiene Escape presionado desregistraba el listener y se perdía esa pulsación.
    if (ev.key !== "Escape") return;
    document.removeEventListener("keyup", onKeyUp, true);
    esperandoKeyUp = false;
    requestClose();
  };
  document.addEventListener("keyup", onKeyUp, true);
};

export default handleSwalAwareEscapeKeyDown;
